import { useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthShell, { Field, PrimaryBtn } from "./AuthShell";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function RegisterManager() {
  const nav = useNavigate();
  const { login } = useAuth();
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [f, setF] = useState({
    name: "", email: "", phone: "", password: "", confirm: "",
    condo_name: "", cnpj: "", cep: "", address: "", number: "", complement: "",
    neighborhood: "", city: "", state: "", towers: 1, units_count: 0,
  });
  const up = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const next = (e) => {
    e.preventDefault();
    if (f.password !== f.confirm) return toast.error("As senhas não coincidem.");
    if (f.password.length < 6) return toast.error("A senha deve ter ao menos 6 caracteres.");
    setStep(2);
  };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { confirm, ...payload } = f;
      payload.towers = Number(f.towers) || 1;
      payload.units_count = Number(f.units_count) || 0;
      const { data } = await api.post("/auth/register/manager", payload);
      login(data.token, data.user);
      toast.success("Condomínio criado! Bem-vindo ao KONDDO.");
      nav("/gestao");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      testid="register-manager-page"
      title="Cadastre seu condomínio"
      subtitle={step === 1 ? "Etapa 1 de 2 — Seus dados" : "Etapa 2 de 2 — Dados do condomínio"}
    >
      {step === 1 ? (
        <form onSubmit={next} className="space-y-4">
          <Field label="Nome completo" data-testid="mgr-name" value={f.name} onChange={up("name")} required />
          <Field label="E-mail" type="email" data-testid="mgr-email" value={f.email} onChange={up("email")} required />
          <Field label="Celular" data-testid="mgr-phone" value={f.phone} onChange={up("phone")} placeholder="(11) 99999-9999" required />
          <div className="grid grid-cols-2 gap-3">
            <Field label="Senha" type="password" data-testid="mgr-password" value={f.password} onChange={up("password")} required />
            <Field label="Confirmar senha" type="password" data-testid="mgr-confirm" value={f.confirm} onChange={up("confirm")} required />
          </div>
          <PrimaryBtn type="submit" data-testid="mgr-next">Continuar</PrimaryBtn>
        </form>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <Field label="Nome do condomínio" data-testid="mgr-condo-name" value={f.condo_name} onChange={up("condo_name")} required />
          <div className="grid grid-cols-2 gap-3">
            <Field label="CNPJ (opcional)" data-testid="mgr-cnpj" value={f.cnpj} onChange={up("cnpj")} />
            <Field label="CEP" data-testid="mgr-cep" value={f.cep} onChange={up("cep")} required />
          </div>
          <div className="grid grid-cols-3 gap-3">
            <div className="col-span-2"><Field label="Endereço" data-testid="mgr-address" value={f.address} onChange={up("address")} required /></div>
            <Field label="Número" data-testid="mgr-number" value={f.number} onChange={up("number")} required />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <Field label="Complemento" data-testid="mgr-complement" value={f.complement} onChange={up("complement")} />
            <Field label="Bairro" data-testid="mgr-neighborhood" value={f.neighborhood} onChange={up("neighborhood")} required />
          </div>
          <div className="grid grid-cols-3 gap-3">
            <div className="col-span-2"><Field label="Cidade" data-testid="mgr-city" value={f.city} onChange={up("city")} required /></div>
            <Field label="Estado" data-testid="mgr-state" value={f.state} onChange={up("state")} placeholder="SP" required />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <Field label="Torres/Blocos" type="number" min="1" data-testid="mgr-towers" value={f.towers} onChange={up("towers")} />
            <Field label="Qtde. unidades" type="number" min="0" data-testid="mgr-units" value={f.units_count} onChange={up("units_count")} />
          </div>
          <div className="flex gap-3">
            <button type="button" onClick={() => setStep(1)} className="flex-1 rounded-full bg-white/5 border border-white/10 py-3 font-medium hover:bg-white/10 transition-colors" data-testid="mgr-back">Voltar</button>
            <div className="flex-1"><PrimaryBtn type="submit" loading={loading} data-testid="mgr-submit">Criar condomínio</PrimaryBtn></div>
          </div>
        </form>
      )}
    </AuthShell>
  );
}
